<template>
  <div class="character">
    <div class="name">
      <ref v-if="character.ref" :id="character.ref"/>
      {{character.name}}
    </div>
    <div class="verses">
      <component v-for="verse in character.elements" :is="verse.class" :verse="verse"/>
    </div>
  </div>
</template>
<script>
  import Verse from './Verse'
  import CharacterProse from './CharacterProse.vue'
  import Ref from './Ref'

  export default {
    components: {Verse, CharacterProse, Ref},
    props: {
      character: {type: Object, required: true}
    }
  }
</script>
<style lang="scss" scoped>
  @import "app/javascript/scss/variables";

  .character {
    position: relative;
    margin-left: $character-name-separation;

    .name {
      position: absolute;
      width: $character-name-width;
      left: -$character-name-separation;
      font-weight: bold;
      text-align: right;

      .ref {
        display: inline-block
      }
    }

    .verses {
      margin-left: $character-name-width;
    }
  }
</style>
